<script type="text/javascript">
	import LoadState from "../../Enums/LoadState";
	import GNSSHotspotsStore from "./Store";
		
	let loadState = GNSSHotspotsStore.meta.loadState;
	let loaded = false;
	$: {
		loaded = $loadState === LoadState.LOADED;
	}

	let visible = GNSSHotspotsStore.meta.visible;
	GNSSHotspotsStore.meta.visible.subscribe((visible) => {
		if (visible) {
			GNSSHotspotsStore.actions.init();
		}
	});

	let lastUpdated = GNSSHotspotsStore.meta.lastUpdated;
	$: {
		$visible;
		$lastUpdated;
		GNSSHotspotsStore.actions.updateVisibility();
	}

	let gnssHotspots = GNSSHotspotsStore.results.gnss;
	// let tankerSTSHotspots = GNSSHotspotsStore.results.tanker;
	// let cargoSTSHotspots = GNSSHotspotsStore.results.cargo;
	// let fishingSTSHotspots = GNSSHotspotsStore.results.fishing;
	
	let gnssVisibility = GNSSHotspotsStore.meta.visibility.gnss;
	// let cargoVisibility = GNSSHotspotsStore.meta.visibility.cargo
	// let fishingVisibility = GNSSHotspotsStore.meta.visibility.fishing;

	$: {
		$lastUpdated;
	}
	$: {
		$gnssVisibility;
		// $cargoVisibility;
		// $fishingVisibility;
		GNSSHotspotsStore.actions.updateVisibility();
	}

</script>

<style>

.hotspot-key-item {
    overflow:hidden;
    margin-bottom:10px;
}
.hotspot-key-item .color-sq {
    margin:5px;
}
.hotspot-key-item p {
    margin:5px;
    margin-left:5px;
}
.hotspot-switch-container {
	padding-top:7px;
	padding-right:10px;
	padding-left:5px;
	float:left;
}

</style>
<!-- 
<ModalWindow
	title={`GNSS Interference Hotspots`}
	hasCloseButton={true}
	hasBackground={false}
	resizable={true}
	draggable={true}
	fullscreen={false}
	padding={false}
	position="top-right"
	height="70%"
	bind:open={$visible} >

    <div class="content padding" style="overflow:hidden;">
        <p><b>Key</b></p>

        <div class="hotspot-key-item">
			<div class='hotspot-switch-container'><Switch bind:checked={$gnssVisibility}/></div>
            <div class='fl color-sq' style={"background-color: " + Paint.hotspots.orange["fill-color"] + ";"}></div>
            <p class='fl'>GNSS Interference</p>
            <p class='fr'>({$gnssHotspots.features.length})</p>
		</div>

    </div>

</ModalWindow> -->

